import {
    animate,
    AnimationTriggerMetadata,
    state,
    style,
    transition,
    trigger,
} from "@angular/animations";

/**
 * Toggle content animation
 */
export const toggleContentAnimation: AnimationTriggerMetadata = trigger(
    "toggleContent",
    [
        state(
            "hidden",
            style({
                transform: "scale(1,0)",
                opacity: 0,
            }),
        ),
        state(
            "visible",
            style({
                transform: "scale(1,1)",
                opacity: 1,
            }),
        ),
        transition(
            "hidden <=> visible",
            animate("200ms cubic-bezier(0.86, 0, 0.07, 1)"),
        ),
    ],
);
